'use client'

import dynamic from 'next/dynamic'

export const NewHeroSectionDynamic = dynamic(
  () => import('@/components/new-home/NewHeroSection'),
  {
    ssr: false,

    loading: () => (
      <div
        className='container px-4 mx-auto py-3 lg:py-6 min-h-[384px] lg:min-h-[540px] rounded-[30px] bg-[#111111] animate-pulse'
        aria-hidden
      />
    ),
  },
)

export const NewEventContainerMenuMobileDynamic = dynamic(
  () => import('@/components/new-home/NewEventContainerMenuMobile'),
  { ssr: false },
)
